module.exports = {
  apiHost: 'www.beeksebergen.nl',
  apiUser: 'api-user-name',
  apiPass: 'api-user-pass',
  domain: 'www.beeksebergen.nl',
  mediaHost: 'd33b12c77av9bg.cloudfront.net',
  // apiHost: 'testing.beeksebergen.jstack.eu',
  // apiUser: 'api-user-name',
  // apiPass: 'api-user-pass',
  // domain: 'testing.beeksebergen.jstack.eu',
  // mediaHost: 'd33b12c77av9bg.cloudfront.net',
};
